module.exports = __webpack_public_path__ + "static/img/steps_app1.a885cc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/steps_app1.png
// module id = 336
// module chunks = 1